module.exports = __webpack_public_path__ + "img/OSM_offlinemap.ea0cf4e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/OSM_offlinemap.jpg
// module id = 47
// module chunks = 0